import styled from 'styled-components';

export const PackageCommonListContainer = styled.div`
  flex-direction: column;
  margin: 0 auto;
  max-width: 100%;
  padding: 0px;
  position: relative;

  .title {
    padding-right: 15px;
    padding-left: 15px;
  }

  .left-arrow,
  .right-arrow {
    position: absolute;
    z-index: 1;
    top: 50%;
    transform: translateY(-50%);
    width: 48px;
    height: 48px;
    border-radius: 24px;
    background-color: white;
    border: 1px solid #ddd;
  }

  .left-arrow {
    left: 24px;
  }

  .right-arrow {
    right: 24px;
  }

  .divider {
    margin: 3px;
    padding-left: 2px;
  }

  .more-packages-mobile {
    display: flex;
    flex-wrap: nowrap;
    overflow-x: scroll;
    width: 100%;

    margin: 0;

    ::-webkit-scrollbar {
      display: none;
    }

    .item {
      min-width: 310px;
      width: 33%;
      padding: 10px;
      padding-left: -10px;
      transition: all 250ms linear;

      &.colombia {
        min-width: 367px;
      }

      &.large {
        width: 50%;
      }

      &.medium {
        width: 100%;
      }
    }
  }

  @media screen and (max-width: 768px) {
    .title {
      padding-left: 24px;
      padding-right: 24px;
    }

    .divider {
      margin: 0 0 18px;
      padding-left: 0;
    }

    .divider h3 {
      font-size: 24px;
      line-height: 30px;
      letter-spacing: 0;
    }

    .more-packages-mobile {
      gap: 16px;
      padding-left: 24px;
      padding-right: 24px;
      scroll-padding-left: 24px;
    }

    .more-packages-mobile .item,
    .more-packages-mobile .item.medium {
      min-width: calc(100% - 58px);
      padding: 0;
      width: calc(100% - 58px);
    }
  }

  .more-packages {
    display: flex;
    flex-wrap: wrap;
    margin: 0;
    max-width: 1100px;

    .item {
      min-width: 300px;
      width: 33%;
      padding: 10px;
      padding-left: -10px;

      &.large {
        width: 50%;
      }

      &.medium {
        width: 100%;
      }
    }
  }
`;
